import { render, staticRenderFns } from "./Liebiao.vue?vue&type=template&id=3d18da66&"
import script from "./Liebiao.vue?vue&type=script&lang=js&"
export * from "./Liebiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports